import { EmailDraftT } from 'lib-shared-legacy-types';

export type LocalStorageEmailDrafts = { drafts: EmailDraftT[] } | null;

const DRAFT_EMAILS_KEY = 'email-drafts';

class DraftEmailHelper {
  getDrafts(): LocalStorageEmailDrafts {
    const savedDrafts = localStorage.getItem(DRAFT_EMAILS_KEY);
    if (!savedDrafts) return null;
    return JSON.parse(savedDrafts as string);
  }

  setDrafts(drafts: LocalStorageEmailDrafts): void {
    localStorage.setItem(DRAFT_EMAILS_KEY, JSON.stringify(drafts));
  }
}

export default new DraftEmailHelper();
